import type { SaveJobAccessAndNotifyTrackingData } from '@seek/hirer-team-member-job-access';

import type { TealiumEventData } from 'src/types/trackingData';

const SET_PREFERENCES = 'notifications-set-preferences-btn-interacted';
const SET_OWN_PREFERENCE = 'notifications-self-confirm-btn-interacted';
const BACK_ON_SET_TEAM_ACCESS_STEP =
  'notifications-team-select-back-btn-interacted';
const BACK_ON_SEND_TEAM_EMAIL_STEP =
  'notifications-team-email-back-btn-interacted';
const ADD_TEAM_MEMBER = 'notifications-add-team-members-now-link-clicked';
const SAVE_JOB_ACCESS = 'notifications-team-select-confirm-btn-interacted';
const SAVE_JOB_EMAIL = 'notifications-team-email-confirm-btn-interacted';

export const clickSetPreference = (): TealiumEventData => ({
  linkName: SET_PREFERENCES,
  eventName: [SET_PREFERENCES],
});

export const clickSaveOwnPreferences = (): TealiumEventData => ({
  linkName: SET_OWN_PREFERENCE,
  eventName: [SET_OWN_PREFERENCE],
});

export const backFromSetTeamAccessStep = (): TealiumEventData => ({
  linkName: BACK_ON_SET_TEAM_ACCESS_STEP,
  eventName: [BACK_ON_SET_TEAM_ACCESS_STEP],
});

export const backFromSetTeamEmailStep = (): TealiumEventData => ({
  linkName: BACK_ON_SEND_TEAM_EMAIL_STEP,
  eventName: [BACK_ON_SEND_TEAM_EMAIL_STEP],
});

export const clickAddTeamMember = (): TealiumEventData => ({
  linkName: ADD_TEAM_MEMBER,
  eventName: [ADD_TEAM_MEMBER],
});

export const clickSaveJobAccessAndNotify = (
  trackingData: SaveJobAccessAndNotifyTrackingData,
): TealiumEventData => {
  const clickSaveJobLinkName =
    trackingData.notificationTeamAddCount > 0
      ? SAVE_JOB_EMAIL
      : SAVE_JOB_ACCESS;

  return {
    linkName: clickSaveJobLinkName,
    eventName: [clickSaveJobLinkName],
    ...trackingData,
  };
};

export const clickProgressPoint = (
  fromStepIndex: number,
  toStepIndex: number,
): TealiumEventData => ({
  eventName: [`notifications-nav-from-step-${fromStepIndex}-to-${toStepIndex}`],
  linkName: `notifications-nav-from-step-${fromStepIndex}-to-${toStepIndex}`,
});

export const IMPRESSION_SELF_PREFERENCE =
  'notifications-widget-self-preference-impression';
export const IMPRESSION_NOTIFY_TEAM =
  'notifications-widget-notify-team-impression';
export const IMPRESSION_EMAIL_TEAM =
  'notifications-widget-custom-email-impression';
export const IMPRESSION_ADD_TEAM = 'notifications-widget-add-team-impression';
export const notificationSettingsImpressionEvent = (
  impressionEventName: string,
): TealiumEventData => ({
  linkName: impressionEventName,
  eventName: [impressionEventName],
});
